

Object.byString = function (o, s) {
  s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  s = s.replace(/^\./, '');           // strip a leading dot
  var a = s.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (k in o) {
      o = o[k];
    } else {
      return;
    }
  }
  return o;
}


export const getLogoAsBse64 = () => {
  return 'data:image/png;base64,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'
}

/**
 * Generate Avatar background color base on name
 * @param name
 * @returns {string}
 */
export const avatarColors = (name) => {

  let charCodes = name
    .split('')
    .map(char => char.charCodeAt(0))
    .join('');

  const colors = [
    "#F44336",
    "#E91E63",
    "#9C27B0",
    "#673AB7",
    "#3F51B5",
    "#03A9F4",
    "#00BCD4",
    "#00AA55",
    "#4CAF50",
    "#8BC34A",
    "#FFC107",
    "#FF9800",
    "#FF5722",
    "#009FD4",
    "#B381B3",
    "#939393",
    "#E3BC00",
    "#D47500",
    "#DC2A2A",
    "#072B7F",
    "#26A69A",
    "#9C27B0",
    "#1D1D1D",
    "#21BA45",
    "#C10015",
    "#31CCEC",
    "#F2C037"
  ];

  return colors[charCodes % colors.length];

}

/**
 * This is only for display
 * Do not use for math
 * @param bytes
 * @returns {string}
 */
export const convertBytes = (bytes) => {
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"]

  if (bytes == 0) {
    return "n/a"
  }

  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)))

  if (i == 0) {
    return bytes + " " + sizes[i]
  }

  return Math.ceil((bytes / Math.pow(1024, i)).toFixed(1)) + " " + sizes[i];

}

export const uuid = () => {
  return '_' + Math.random().toString(36).substr(2, 9);
}

/**
 * Returns a copy of select options sorted alphabetically (case-insensitive,
 * numeric-aware) by the given key. Non-arrays are returned untouched.
 */
export const sortOptions = (options, key = 'label') => {
  if (!Array.isArray(options)) {
    return options;
  }

  return options.slice().sort(function (a, b) {
    var A = String((a && a[key]) || ''), B = String((b && b[key]) || '');

    return A.localeCompare(B, undefined, {sensitivity: 'base', numeric: true});
  });
};

/**
 * Filters select options that may contain group headers ({header: true}, each
 * followed by its group's options). A header stays while any option of its
 * group still matches.
 */
export const filterGroupedOptions = (options, matches) => {
  return options.filter((item, index) => {
    if (!item.header) {
      return matches(item);
    }
    for (let i = index + 1; i < options.length && !options[i].header; i++) {
      if (matches(options[i])) {
        return true;
      }
    }
    return false;
  });
};

export const mapOrder = (array, order, key) => {
  array.sort(function (a, b) {
    var A = a[key], B = b[key];

    if (order.indexOf(A) > order.indexOf(B)) {
      return 1;
    } else {
      return -1;
    }

  });

  return array;
};

export const assignForm = (obj1, obj2) => {

  obj2 = deepClone(obj2);

  Object.keys(obj2).forEach(function (key) {
    if (key in obj1) {
      obj1[key] = obj2[key];
    }
  });
  return obj1;
}

export const deepClone = (object) => {
  return JSON.parse(JSON.stringify(object));
}

export const localStorageSpace = () => {
  var allStrings = '';
  for (var key in window.localStorage) {
    allStrings += key;
    if (window.localStorage.hasOwnProperty(key)) {
      allStrings += window.localStorage[key];
    }
  }
  return allStrings ? 3 + ((allStrings.length * 16) / (8 * 1024)) + ' KB' : 'Empty (0 KB)';
};

export const mergeArrayObjects = (a, b, prop) => {
  var reduced = a.filter(function (aitem) {
    return !b.find(function (bitem) {
      return aitem[prop] === bitem[prop];
    });
  });
  return reduced.concat(b);
}

export const openInNewTab = (url) => {
  window.open(url, '_blank').focus();
}


export const setAll = (obj, val) => Object.keys(obj).forEach(k => obj[k] = val);

export const generatePassword = (len = 10) => {
  const alpha = 'abcdefghijklmnopqrstuvwxyz';
  const calpha = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const num = '1234567890';
  const specials = '!@#$%^&*';
  const options = [alpha, alpha, alpha, calpha, calpha, num, num, specials];
  let opt, choose;
  let pass = "";
  for (let i = 0; i < len; i++) {
    opt = Math.floor(Math.random() * options.length);
    choose = Math.floor(Math.random() * (options[opt].length));
    pass = pass + options[opt][choose];
    options.splice(opt, 1);
  }
  return pass;
}


export const escapeHTML = (unsafeText) => {
  let div = document.createElement('div');
  div.innerHTML = unsafeText;
  return div.innerText.slice(0, 230) + '...';
}


export const deepCompare = (obj1, obj2) => {
// Check if both are objects
  if (typeof obj1 !== 'object' || typeof obj2 !== 'object') {
    return false;
  }

  // Check if both are null
  if (obj1 === null && obj2 === null) {
    return true;
  }

  // Check if both have the same number of properties
  if (Object.keys(obj1).length !== Object.keys(obj2).length) {
    return false;
  }

  // Check each property deeply
  for (let key in obj1) {
    if (!obj2.hasOwnProperty(key)) {
      return false;
    }

    const val1 = obj1[key];
    const val2 = obj2[key];

    if (typeof val1 === 'object' && typeof val2 === 'object') {
      if (!deepCompare(val1, val2)) {
        return false;
      }
    } else if (val1 !== val2) {
      return false;
    }
  }

  return true;
}

export default {
  convertBytes,
  avatarColors,
  localStorageSpace,
  deepClone,
  mapOrder,
  assignForm,
  uuid,
  mergeArrayObjects,
  openInNewTab,
  setAll,
  generatePassword,
  escapeHTML,
  deepCompare,
  getLogoAsBse64
}
